import { ReactNode } from 'react';

// components
import TableCore from './TableCore';

export type TableColumn<TableRowData extends Record<string, unknown>> = {
  field: keyof TableData<TableRowData>;
  title?: string;
  render?: (data: TableData<TableRowData>) => ReactNode;
  renderHeadCell?: (
    data: Pick<TableColumn<TableRowData>, 'field' | 'title'>,
  ) => ReactNode;
};

export type TableProps<TableRowData extends Record<string, unknown>> = {
  columns: TableColumn<TableRowData>[];
  data: TableRowData[];
  disableLastBorder?: boolean;
};

export type TableData<
  TableRowData extends Record<string, unknown>
> = TableRowData & {
  __id: string;
};

/**
 * @component Table
 */
function Table<TableRowData extends Record<string, unknown>>(
  props: TableProps<TableRowData>,
) {
  return <TableCore {...props} />;
}

export default Table;
